import styled from "styled-components";

const MediaSectionStyle = styled.div`
  position: relative;
  box-shadow: 0px 25px 50px rgba(22, 25, 79, 0.05);
  border-radius: 50px;
  background: rgba(255, 255, 255, 0.1);
  overflow: hidden;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  padding: 3rem 4rem;

  .secondary-heading {
    text-align: center;
    margin-bottom: 2rem;
  }

  .secondary-heading h2 {
    font-size: 3.6rem;
    font-weight: 700;
    ${'' /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */}
    ${'' /* -webkit-background-clip: text;
    -webkit-text-fill-color: transparent; */}
    background-clip: text;
    margin-bottom: 0.5rem;
  }

  .section-subtitle {
    font-size: 1.6rem;
    color: #212121;
    margin-top: 0.5rem;
  }

  /* YouTube Videos Section */
  .youtube-section {
    margin-bottom: 4rem;
  }

  .subsection-title {
    font-size: 2rem;
    font-weight: 600;
    margin-bottom: 2rem;
    color: #333;
    position: relative;
    padding-bottom: 0.5rem;
  }

  .subsection-title::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 60px;
    height: 3px;
    background: linear-gradient(135deg, #ea6666 0%, #a2514b 100%);
  }

  .video-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 2rem;
    margin-bottom: 3rem;
  }

  .video-wrapper {
    position: relative;
    padding-bottom: 56.25%; /* 16:9 aspect ratio */
    height: 0;
    overflow: hidden;
    border-radius: 12px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }

  .video-wrapper:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.25);
  }

  .video-wrapper iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
    border-radius: 12px;
  }

  /* Images Section */
  .images-section {
    margin-top: 4rem;
  }

  .image-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 2rem;
  }

  .pic-hover {
    width: 100%;
    position: relative;
    overflow: hidden;
    border-radius: 12px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    transition: all 0.5s ease;
  }

  .pic-hover:hover {
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);
    transform: translateY(-5px);
  }

  .bg-overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1;
    background: rgba(0, 0, 0, 0);
    transition: all 0.5s ease;
  }

  .pic-hover:hover .bg-overlay {
    background: rgba(102, 126, 234, 0.3);
  }

  .pic-hover img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
    display: block;
  }

  .pic-hover.hover-scale:hover img {
    transform: scale(1.1);
  }

  .mb30 {
    margin-bottom: 0;
  }

  /* Responsive */
  @media (max-width: 768px) {
    padding: 2rem 1.5rem;

    .secondary-heading h2 {
      font-size: 2.5rem;
    }

    .subsection-title {
      font-size: 1.5rem;
    }

    .video-grid,
    .image-grid {
      grid-template-columns: 1fr;
      gap: 1.5rem;
    }
  }
`;

export default MediaSectionStyle;
export const MediaTwoSectionStyle = styled.div`
 position: relative;
  box-shadow: 0px 25px 50px rgba(22, 25, 79, 0.05);
  border-radius: 50px;
  background: rgba(255, 255, 255, 0.1);
  overflow: hidden;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  padding: 3rem 4rem;

  .secondary-heading {
    text-align: center;
    margin-bottom: 2rem;
  }

  .secondary-heading h2 {
    font-size: 3.6rem;
    font-weight: 700;
    ${'' /* background: linear-gradient(135deg, #ea6666 0%, #a25c4b 100%); */}
    ${'' /* -webkit-background-clip: text; */}
    ${'' /* -webkit-text-fill-color: transparent; */}
    background-clip: text;
    margin-bottom: 0.5rem;
  }

  .section-subtitle {
    font-size: 1.6rem;
    color: #2b2b2b;
    margin-top: 0.5rem;
  }

  /* YouTube Videos Section */
  .youtube-section {
    margin-bottom: 4rem;
  }

  .subsection-title {
    font-size: 2rem;
    font-weight: 600;
    margin-bottom: 2rem;
    color: #333;
    position: relative;
    padding-bottom: 0.5rem;
  }

  .subsection-title::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 60px;
    height: 3px;
    background: linear-gradient(135deg, #ea6666 0%, #a24b4b 100%);
  }

  .video-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 2rem;
    margin-bottom: 3rem;
  }

  .video-wrapper {
    position: relative;
    padding-bottom: 56.25%; /* 16:9 aspect ratio */
    height: 0;
    overflow: hidden;
    border-radius: 12px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }

  .video-wrapper:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.25);
  }

  .video-wrapper iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
    border-radius: 12px;
  }

  /* Images Section */
  .images-section {
    margin-top: 4rem;
  }

  .image-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 2rem;
  }

  .pic-hover {
    width: 100%;
    position: relative;
    overflow: hidden;
    border-radius: 12px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    transition: all 0.5s ease;
  }

  .pic-hover:hover {
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);
    transform: translateY(-5px);
  }

  .bg-overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1;
    background: rgba(0, 0, 0, 0);
    transition: all 0.5s ease;
  }

  .pic-hover:hover .bg-overlay {
    background: rgba(102, 126, 234, 0.3);
  }

  .pic-hover img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
    display: block;
  }

  .pic-hover.hover-scale:hover img {
    transform: scale(1.1);
  }

  .mb30 {
    margin-bottom: 0;
  }

  /* Responsive */
  @media (max-width: 768px) {
    padding: 2rem 1.5rem;

    .secondary-heading h2 {
      font-size: 2.5rem;
    }

    .subsection-title {
      font-size: 1.5rem;
    }

    .video-grid,
    .image-grid {
      grid-template-columns: 1fr;
      gap: 1.5rem;
    }
  }
`;